import React from 'react';
import { Box } from '@qwealth/qcore';
import { WarningBox } from './NotesPreviewCardStyles';
import { BsFillExclamationTriangleFill } from 'react-icons/bs';

const WealthboxConflictTag: React.FC = () => (
  <WarningBox
    alignItems="center"
    borderRadius="default"
    paddingLeft="default"
    paddingRight="default"
  >
    <Box
      color="dark"
      padding="small"
      fontWeight="bold"
      fontSize="small"
      height="27px"
      display="flex"
      flexDirection="row"
      gap="small"
    >
      <Box color="warning">
        <BsFillExclamationTriangleFill size="22px" />
      </Box>
      <Box alignItems="center" paddingTop="small">
        Wealthbox Conflict
      </Box>
    </Box>
  </WarningBox>
);

export default WealthboxConflictTag;
